








































import { Component, Vue, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";

@Component
export default class SurveyConfirmDialog extends Vue {
  @Ref("survey-confirm-dialog")
  dialog!: QDialog;

  onSubmit() {
    this.$emit("ok", true);
    this.hide();
  }

  onCancelButton() {
    this.$emit("ok", false);
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
